var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "messages" }, [
    _c("div", { staticClass: "messages_block" }, [
      _c(
        "div",
        { staticClass: "messages_list" },
        _vm._l(_vm.messages, function (message) {
          return _c(
            "div",
            {
              key: message.id,
              class: {
                single_message: true,
                my_message: +message.user_id === _vm.$currentUID,
              },
            },
            [
              _c(
                "div",
                { staticClass: "author" },
                [
                  _vm.hideNames
                    ? [
                        +message.user_id !== _vm.$currentUID
                          ? _c("span", [_vm._v("Менеджер")])
                          : _vm._e(),
                      ]
                    : [
                        +message.user_id !== _vm.$currentUID
                          ? [
                              message.user
                                ? [_vm._v(_vm._s(message.user.name))]
                                : [
                                    _c("UserName", {
                                      attrs: { id: +message.user_id },
                                    }),
                                  ],
                            ]
                          : _vm._e(),
                      ],
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted message_date" }, [
                    _vm._v(
                      _vm._s(_vm.printDate(message.created_at, "DD.MM HH:mm"))
                    ),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "triangle" }),
              _vm._v(" "),
              _c("div", { staticClass: "message" }, [
                _c("div", {
                  staticClass: "body",
                  domProps: { innerHTML: _vm._s(message.message) },
                }),
                _vm._v(" "),
                _vm.isReadMessage(message)
                  ? _c("span", { staticClass: "read_marker" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.printDate(
                              message.acknowledge_by[0].date,
                              "DD.MM HH:mm",
                              false,
                              0
                            )
                          ) +
                          " "
                      ),
                      _c("i", { staticClass: "icon-fa icon-fa-check" }),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "post_message" },
      [
        !_vm.dialogAccepted
          ? [
              _c("LoadingButton", {
                attrs: {
                  title: "Принять запрос",
                  loading: _vm.loading,
                  color: _vm.$constants.SUCCESS_COLOR,
                  onClick: () => _vm.acceptDialog(),
                  className: "btn btn-outline-success br-0 w-100",
                },
              }),
            ]
          : [
              _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.sendMessage.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.message,
                          expression: "message",
                        },
                      ],
                      staticClass: "form-control br-0",
                      attrs: {
                        type: "text",
                        disabled: _vm.loading,
                        required: "",
                        placeholder: "Сообщение",
                      },
                      domProps: { value: _vm.message },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.message = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "input-group-append" },
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Отправить",
                            type: "submit",
                            loading: _vm.loading,
                            color: _vm.$constants.LOADING_COLOR,
                            onClick: () => {},
                            className: "btn btn-outline-info br-0",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }